module.exports = __webpack_public_path__ + "static/media/pharmacist.4900608a.png";